import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./Components/Layouts/Layout";
import About from "./Pages/About";
import Login from "./Components/Form/Login.jsx";
import SignUp from "./Components/Form/SignUp.jsx";
import Blog from "./Pages/Blog.jsx";
import Help from "./Pages/Help.jsx";
import PlanDetails from "./Pages/PlanDetails";
import Cart from "./Pages/Cart";
import Medicines from "./Pages/MedicineDetail.jsx";
import Vaccination from "./Pages/Vaccination";
import Grooming from "./Pages/Grooming";
import Order from "./Pages/Order";
import Prediction from "./Pages/Prediction";
import { CartProvider } from "./context/CartContext.jsx";
import BuyNowPage from "./Pages/BuyNow.jsx";
import { SearchProvider } from "./context/SearchContext.jsx";
import ResetPassword from "./Components/Form/ResetPassword.jsx";
import { AuthProvider } from "./context/AuthContext.jsx";
import { ToastContainer } from "react-toastify";
import { SearchToggleProvider } from "./context/SearchToggleContext.jsx";
import "react-toastify/dist/ReactToastify.css";
import NotFound from "./Components/Other/NotFound.jsx";



const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <App />,
      },
      {
        path: "/about",
        element: <About />,
      },

      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/signup",
        element: <SignUp />,
      },
      {
        path: "/blogs",
        element: <Blog />,
      },
      {
        path: "/help",
        element: <Help />,
      },
      {
        path: "/medicines",
        element: <Medicines />,
      },
      {
        path: "/vaccination",
        element: <Vaccination />,
      },
      { path: "/grooming", element: <Grooming /> },
      { path: "/plans/:petType", element: <PlanDetails /> },

      { path: "/cart", element: <Cart /> },

      { path: "/orders", element: <Order /> },

      {
        path: "/cart/checkout",
        element: <BuyNowPage />,
      },
      {
        path: "/prediction",
        element: <Prediction />,
      },
      {
        path: "/reset-password/:token",
        element: <ResetPassword />,
      },
      {
        path:"*",
        element:<NotFound/>
      }
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <CartProvider>
        <SearchProvider>
          <SearchToggleProvider>
          <RouterProvider router={router} />
          </SearchToggleProvider>
        </SearchProvider>
      </CartProvider>
    </AuthProvider>
    <ToastContainer position="top-center" />
  </React.StrictMode>
);

reportWebVitals();
export default router;
